import { render } from "./TelegramLogin.vue?vue&type=template&id=ef856afc"
import script from "./TelegramLogin.vue?vue&type=script&lang=js"
export * from "./TelegramLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__